// @flow
import styled from 'styled-components';

// eslint-disable-next-line import/prefer-default-export
export const NotFound = styled.p`
  align-items: center;
  display: flex;
  height: 100vh;
  justify-content: center;
`;



// WEBPACK FOOTER //
// ./src/components/sessions/view/styles.js